import classNames from 'clsx';
import React, { memo, useCallback } from 'react';
import { updatedUnsubScreensEnabled } from 'reactApp/appHelpers/featuresHelpers/features/overquotaNewUnsub';
import { Button, ButtonSizeMode } from 'reactApp/ui/Button/Button';
import styles from 'reactApp/ui/PollPopup/PollPopup.css';

interface SelectableButtonProps {
    title: string;
    onClick(id: string);
    isSelected?: boolean;
    isPhone?: boolean;
}

// eslint-disable-next-line react/display-name
export const SelectableButton = memo(({ title, onClick, isSelected, isPhone }: SelectableButtonProps) => {
    const choiceClick = useCallback(
        (e: React.MouseEvent) => {
            e.stopPropagation();

            onClick(title);
        },
        [onClick, title]
    );

    return (
        <Button
            className={classNames(updatedUnsubScreensEnabled ? styles.buttonNew : styles.button, {
                [styles.button_selected]: isSelected,
                [styles.button_mobile]: isPhone,
            })}
            onClick={choiceClick}
            theme="octavius"
            sizeMode={updatedUnsubScreensEnabled ? ButtonSizeMode.small : undefined}
        >
            {title}
        </Button>
    );
});
